import { render, staticRenderFns } from "./StuNav.vue?vue&type=template&id=425fad34&scoped=true&"
import script from "./StuNav.vue?vue&type=script&lang=js&"
export * from "./StuNav.vue?vue&type=script&lang=js&"
import style0 from "./StuNav.vue?vue&type=style&index=0&id=425fad34&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425fad34",
  null
  
)

export default component.exports